/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.controllers', [])

.controller('PosController', ['$scope', function($scope) {

    $scope.pos = {

      model: "Your spankin new application.pos.default view!",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.pos.init();

}]);